/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Permissions_Permission_CountInputs */

const en_tables_permissions_permission_count = /** @type {(inputs: Tables_Permissions_Permission_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission Count`)
};

const de_tables_permissions_permission_count = /** @type {(inputs: Tables_Permissions_Permission_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Berechtigungen`)
};

/**
* | output |
* | --- |
* | "Permission Count" |
*
* @param {Tables_Permissions_Permission_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_permissions_permission_count = /** @type {((inputs?: Tables_Permissions_Permission_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Permissions_Permission_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_permissions_permission_count(inputs)
	return de_tables_permissions_permission_count(inputs)
});